<!-- Dialog Affichant le détail d'une campagne/Diffusion Wanview passée en paramètre -->
<div mat-dialog-content style="max-height: 70vh !important">
    <div class="globalContainer">
        @if (isDiffLoading) {
            <div class="loadingContainer">
                <mat-spinner [diameter]="50"></mat-spinner>
                <i class="text">Chargement du détail de la diffusion...</i>
            </div>
        } @else {
            <!-- MARK: Détail de la diff -->
            <div class="diffDetailContainer">
                <!-- Spot Content -->
                <div class="spotContainer">
                    @if (diffusionDetail?.storageId) {
                        <app-player [fileStorageId]="diffusionDetail.storageId"></app-player>
                    } @else {
                        <div class="noSpot">
                            <mat-icon>broken_image</mat-icon>
                            <p>Aucun visuel</p>
                        </div>
                    }
                </div>
                <!-- MARK: Diffusion params -->
                <div class="diffParams">
                    <div class="paramLine active">
                        <h1>
                            Détail de la diffusion <b>{{ diffusionName }}</b>
                        </h1>
                    </div>

                    <!-- Badge Duration -->
                    <span [ngClass]="getDeltaItemClass(diffusionDetail)">
                        {{ getDayDelta(diffusionDetail) }}
                    </span>
                    <!-- Dates -->
                    <div class="paramLine active" matTooltip="Paramètre de dates">
                        <mat-icon>event</mat-icon>
                        <div class="content">{{ getDisplayDate() }}</div>
                    </div>
                    <!-- Horaires -->
                    <div
                        class="paramLine"
                        [ngClass]="diffusionDetail.startHour && diffusionDetail.endHour ? 'active' : ''"
                        matTooltip="Paramètre d'horaires"
                    >
                        <mat-icon>schedule</mat-icon>
                        @if (diffusionDetail.startHour && diffusionDetail.endHour) {
                            <div class="content">{{ diffusionDetail.startHour }} - {{ diffusionDetail.endHour }}</div>
                        } @else {
                            <div></div>
                        }
                    </div>
                    <!-- Température -->
                    <div
                        class="paramLine"
                        [ngClass]="diffusionDetail.minTemp && diffusionDetail.maxTemp ? 'active' : ''"
                        matTooltip="Paramètre de température"
                    >
                        <mat-icon>thermostat</mat-icon>
                        @if (diffusionDetail.minTemp && diffusionDetail.maxTemp) {
                            <div class="content">
                                De {{ diffusionDetail.minTemp }}°C à {{ diffusionDetail.maxTemp }}°C
                            </div>
                        } @else {
                            <div></div>
                        }
                    </div>
                    <!-- Météo -->
                    <div
                        class="paramLine"
                        [ngClass]="diffusionDetail.weather ? 'active' : ''"
                        matTooltip="Paramètre de météo"
                    >
                        @if (diffusionDetail.weather) {
                            <mat-icon>{{ weatherParamsIcons[diffusionDetail.weather] }}</mat-icon>
                            <div class="content">{{ weatherParams[diffusionDetail.weather] }}</div>
                        } @else {
                            <mat-icon>cloud_off</mat-icon>
                            <div></div>
                        }
                    </div>
                    <!-- Jours de diffusion -->
                    @if (diffusionDetail?.diffusionDays != null && diffusionDetail?.diffusionDays != []) {
                        <div class="paramLine" matTooltip="Jours de diffusion">
                            <section class="days">
                                <span [ngClass]="[diffusionDetail.diffusionDays.indexOf(1) != -1 ? '' : 'inactive']">
                                    L
                                </span>
                                <span [ngClass]="[diffusionDetail.diffusionDays.indexOf(2) != -1 ? '' : 'inactive']">
                                    M
                                </span>
                                <span [ngClass]="[diffusionDetail.diffusionDays.indexOf(3) != -1 ? '' : 'inactive']">
                                    M
                                </span>
                                <span [ngClass]="[diffusionDetail.diffusionDays.indexOf(4) != -1 ? '' : 'inactive']">
                                    J
                                </span>
                                <span [ngClass]="[diffusionDetail.diffusionDays.indexOf(5) != -1 ? '' : 'inactive']">
                                    V
                                </span>
                                <span [ngClass]="[diffusionDetail.diffusionDays.indexOf(6) != -1 ? '' : 'inactive']">
                                    S
                                </span>
                                <span [ngClass]="[diffusionDetail.diffusionDays.indexOf(7) != -1 ? '' : 'inactive']">
                                    D
                                </span>
                            </section>
                        </div>
                    }
                </div>
            </div>
        }
        <!-- MARK: Ecrans où diffuse la diff -->
        <div class="facesContainer">
            @if (isFacesLoading) {
                <div class="loadingContainer">
                    <mat-spinner [diameter]="40"></mat-spinner>
                    <i class="text">Chargement des faces de la diffusion...</i>
                </div>
            } @else {
                <h3>
                    @if (totalFaces > 1) {
                        <b>{{ totalFaces }}</b> Ecrans liés à la diffusion
                    } @else {
                        Ecran lié à la diffusion
                    }
                </h3>
                @for (face of facesInfos; track $index) {
                    <mat-card class="screenCard">
                        <mat-card-content style="padding: 0 10px 0 0">
                            <div class="content">
                                <!-- ScreenThumbnail -->
                                @if (face?.thumbnailId) {
                                    <img
                                        matTooltip="Voir l'image de l'écran"
                                        class="thumbnail"
                                        [src]="baseUrl + '/file/getFile/' + face.thumbnailId + '/' + face.thumbnailId"
                                        alt="Miniature de l'écran"
                                        (click)="playScreenFile(face.storageId)"
                                    />
                                } @else {
                                    <div class="thumbnail noContent">Dispositif sans photo</div>
                                }
                                <!-- ScreenInfos -->
                                <div class="screenInfos">
                                    <div>
                                        <p class="screenName">{{ face.screenName }}</p>
                                        <p class="screenAdress">
                                            {{ face.screenAddress }}
                                            {{ face.zipCode }} {{ face.cityName }}
                                        </p>
                                    </div>
                                    @if (face.screenTags) {
                                        <span class="tagList">
                                            @for (tag of face.screenTags; track $index) {
                                                <span class="tag">
                                                    {{ tag.name }}
                                                </span>
                                            }
                                        </span>
                                    }
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
            }

            @if (totalFaces > faceFilterParams.pageSize) {
                <!-- Paginator Screen -->
                <mat-paginator
                    [length]="totalFaces"
                    [pageSize]="faceFilterParams.pageSize"
                    [pageIndex]="faceFilterParams.page"
                    [showFirstLastButtons]="true"
                    (page)="pageFaces($event)"
                >
                </mat-paginator>
            }
        </div>
    </div>
</div>

<div mat-dialog-actions style="justify-content: flex-end">
    <button mat-stroked-button color="secondary" mat-dialog-close>Fermer</button>
</div>
